import { useQuery } from 'react-query';
import { LoginPopupsService } from '~/api/services/loginPopups';
import { onError } from '~/utils/helpers';

const getLoginPopupsList = (data?) => useQuery(
  `login-popups-list-${JSON.stringify(data)}`,
  () => LoginPopupsService.getLoginPopupsList(),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

export const LoginPopupsQuery = {
  getLoginPopupsList
}
